// Generated by CoffeeScript 2.7.0
var FileHelper, HEADIMGURL_SIZE;

HEADIMGURL_SIZE = {
  tiny: 46,
  small: 64,
  normal: 96,
  large: 132,
  huge: 0
};

FileHelper = {
  humanSize: function(number) {
    var kbs;
    kbs = number / 1024;
    if (kbs / 1024 > 1024) {
      return `${(kbs / (1024 * 1024)).toFixed(2)} GB`;
    } else if (kbs / 1024 > 0.3) {
      return `${(kbs / 1024).toFixed(1)} MB`;
    } else if (kbs >= 1) {
      return `${kbs.toFixed(2)} KB`;
    } else {
      return `${kbs.toFixed(3)} KB`;
    }
  },
  fileExtension: function(mimeType) {
    var _doc, _pdf, _ppt, _xls, _zip, extensionKeywords, matchData, re;
    _pdf = 'pdf';
    _ppt = 'powerpoint';
    _xls = 'excel';
    _zip = 'archive';
    _doc = 'word';
    extensionKeywords = {
      csv: _xls, // mime-type of csv is 'text/csv', keep it in front of 'text/'
      'image/svg': _zip,
      'image/': 'image',
      'video/': 'video',
      'audio/': 'audio',
      'text/': 'text',
      pdf: _pdf,
      powerpoint: _ppt,
      presention: _ppt,
      excel: _xls,
      preadsheet: _xls,
      'comma-separated-values': _xls,
      zip: _zip,
      rar: _zip,
      gz: _zip,
      tar: _zip,
      compress: _zip,
      'octet-strea': _zip,
      word: 'doc'
    };
    re = new RegExp(_.keys(extensionKeywords).join('|'));
    if (matchData = mimeType.match(re)) {
      return extensionKeywords[_.first(matchData)];
    } else {
      return 'unknown';
    }
  },
  headimgWithSize: function(url, {size} = {
      size: 'tiny'
    }) {
    if (url.match(/^\/non-digested-assets\/avatars\//)) {
      if (HEADIMGURL_SIZE[size] === 0) {
        return url;
      } else {
        return url.replace(/^\/non-digested-assets\/avatars\/(.*)\.png/, `/non-digested-assets\/avatars\/$1_${HEADIMGURL_SIZE[size]}\.png`);
      }
    } else {
      return `${url}/${HEADIMGURL_SIZE[size]}`;
    }
  }
};

export default FileHelper;
